import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from "@elastic/eui";
import ConformityCards from "components/Outdoor_Cameras/IN-9808_QFHD/Safety_Warnings/ConformityCards";
import NavButtons from "components/Outdoor_Cameras/IN-9808_QFHD/NavButtons";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "IN-9808 4K (QFHD) Sicherheit Hinweise",
  "path": "/Aussenkameras/IN-9808_QFHD/Sicherheit_Hinweise/",
  "dateChanged": "2017-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Die IN-9808 4K (QFHD) ist die erste INSTAR IP-Überwachungskamera für den Außenbereich, die unseren neuen Sony 2160p / QFHD STARVIS-Sensor verwendet",
  "image": "./P_SearchThumb_IN-9008HD_Warranty.png",
  "social": "/images/Search/P_SearchThumb_IN-9408WQHD_Warranty.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-IN-9008HD_white.webp",
  "chapter": "Outdoor Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title="IN-9808 4K (QFHD) Sicherheit Hinweise" dateChanged="2017-12-12" author="Mike Polinowski" tag="INSTAR IP Camera" description="Die IN-9808 4K (QFHD) ist die erste INSTAR IP-Überwachungskamera für den Außenbereich, die unseren neuen Sony 2160p / QFHD STARVIS-Sensor verwendet." image="/images/Search/P_SearchThumb_IN-9408HD_Warranty.png" twitter="/images/Search/P_SearchThumb_IN-9408HD_Warranty.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Outdoor_Cameras/IN-9808_QFHD/Safety_Warnings/" locationFR="/fr/Outdoor_Cameras/IN-9808_QFHD/Safety_Warnings/" crumbLabel="Safety" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h2 {...{
      "id": "in-9808-4k-qfhd-sicherheitshinweise",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#in-9808-4k-qfhd-sicherheitshinweise",
        "aria-label": "in 9808 4k qfhd sicherheitshinweise permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IN-9808 4K QFHD Sicherheitshinweise`}</h2>
    <h3 {...{
      "id": "haftungsausschluss",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#haftungsausschluss",
        "aria-label": "haftungsausschluss permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Haftungsausschluss`}</h3>
    <p>{`Alle technischen Angaben und Beschreibungen in diesem Handbuch wurden mit größter Sorgfalt erstellt. Dennoch kann die INSTAR Deutschland GmbH Fehler in diesem Handbuch nicht vollständig ausschließen. Wir übernehmen daher keine juristische Verantwortung oder Haftung, die sich aus falschen Angaben in diesem Handbuch ergeben. Änderungen von Beschreibungen, technischen Abbildungen und technischen Daten im Sinne des technischen Fortschritts bleiben vorbehalten. Darüber hinaus behält sich die INSTAR Deutschland GmbH das Recht vor, dieses Produkt und die Bedienungsanleitung ohne vorherige Ankündigung zu ändern. Für den Inhalt dieses Dokuments übernehmen wir keine Gewähr.`}</p>
    <h3 {...{
      "id": "warnung-vor-elektrischen-schlägen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#warnung-vor-elektrischen-schl%C3%A4gen",
        "aria-label": "warnung vor elektrischen schlägen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Warnung vor elektrischen Schlägen`}</h3>
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "424px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/e26eb88d71740179dea1469cc8ef86f1/1cfa9/ElectricShock_Caution.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.60869565217391%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAACvklEQVQozzWQ20/TYBjGe+Uhxn9EE0z8izRG4wXxcE3UW9wYA5FBguO0xHEqrkUYIWxz28W6dm3Xr/2+nr/RdmETxEzHdrEDnxnE3+UvefM870NZliXLssALumFkM9nF2MJyfDmxnlhbXd1IbiS/JhPrieV4fDG2kMlkDMMQhIooSbqu7+zQFCGk2WyWSxwhZHtz6/6du2MPHj578vTV+PjL5y/evn7z4d37x2OP7t26vZlMEkKqslyvB4QQCOHouJgvri6vtNttVVWj09HE2np6/yB9kN7Z3mYZJn2Q/rK0NDf7CUHU7XZX4vFioTAcDmW5SnUuOxhjsVJpNprNZrPb7RJCAj+o4Vqj0fBOakEQDIfDfr/Xav1pNBqWaWLX/X1xASGiBEH4kcsdHR0Vi8Uyx0mSpKpqPp/PHB8XCoVcLpc5PlYBkGRJEIRCPs9xHFcqFfOFbDZLHR4e0jTNsuzW1tbu7m4qlaJpmmEYhmUZltnb22NYlqbp1Ldvqf/s0vT3/f1YLDb6GWoQarCGMYTQMs1Wq+V7HlAAgtC2LMd2zs7OoKbdSNdxMMady0vHcah+v69pGlCAbVlljnNd17Ft9RrP85SqYpmmCoB/4lVlWaxUlGoVQji8Guq6Pkp2XNfQdexiy7JcjG8CPc8LggC7LkLIvB4JXQM1aOh6r9czTZMaDAZiRRQFQakqQFEkUawIgmPbOkIqAFDTuFJJBYDneRWAMsdVZblcLrf/tm3bpnq9nsDzUNNqGEuiBIAqS5Lv+5IoaqoKNYgg5HleRzpCSFEUx3FqGHc6HYTQqHYN43pQb5yeuqNtfjqWjV03CIJf5+feiWfoRj0ILNOsYTwYDAghV1dXhBDf96n5+fnJyY+hUHhqKjIVngqHw6FQKDI9fWOi0Wh4pMKRSGTkI5HZ2dmZmZm5uc8TExP/ANGQYDj8wj4wAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/e26eb88d71740179dea1469cc8ef86f1/e4706/ElectricShock_Caution.avif 230w", "/de/static/e26eb88d71740179dea1469cc8ef86f1/8b5ae/ElectricShock_Caution.avif 424w"],
              "sizes": "(max-width: 424px) 100vw, 424px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/e26eb88d71740179dea1469cc8ef86f1/a0b58/ElectricShock_Caution.webp 230w", "/de/static/e26eb88d71740179dea1469cc8ef86f1/96b95/ElectricShock_Caution.webp 424w"],
              "sizes": "(max-width: 424px) 100vw, 424px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/e26eb88d71740179dea1469cc8ef86f1/81c8e/ElectricShock_Caution.png 230w", "/de/static/e26eb88d71740179dea1469cc8ef86f1/1cfa9/ElectricShock_Caution.png 424w"],
              "sizes": "(max-width: 424px) 100vw, 424px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/e26eb88d71740179dea1469cc8ef86f1/1cfa9/ElectricShock_Caution.png",
              "alt": "Electric Shock Warning",
              "title": "Electric Shock Warning",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Bei Schäden, die durch Nichtbeachtung dieser Anleitung entstehen, erlischt der Gewährleistungsanspruch. Für Folgeschäden übernehmen wir keine Haftung. Wir übernehmen keine Haftung für Personen- und/oder Sachschäden jeglicher Art, die durch unsachgemäße Handhabung oder Nichtbeachtung der Sicherheitshinweise entstehen. Der Garantieanspruch erlischt in solchen Fällen!`}</p>
    <h3 {...{
      "id": "bitte-lesen-sie-die-folgenden-sicherheitshinweise-sorgfältig-durch",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bitte-lesen-sie-die-folgenden-sicherheitshinweise-sorgf%C3%A4ltig-durch",
        "aria-label": "bitte lesen sie die folgenden sicherheitshinweise sorgfältig durch permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bitte lesen Sie die folgenden Sicherheitshinweise sorgfältig durch:`}</h3>
    <ul>
      <li parentName="ul">{`Achten Sie darauf, dass das Netzkabel nicht in der Nähe von heißen Oberflächen liegt.`}</li>
      <li parentName="ul">{`Verlegen Sie das Netz- und das Netzwerkkabel so, dass niemand verletzt werden kann.`}</li>
      <li parentName="ul">{`Dieses Gerät darf nicht von Personen (einschließlich Kindern) mit eingeschränkten körperlichen, sensorischen und geistigen Fähigkeiten verwendet werden. Das Gerät darf nur von geschulten Personen benutzt werden, die mit dem Gerät sorgfältig umgehen können.`}</li>
      <li parentName="ul">{`Kinder sollten beaufsichtigt werden, um sicherzustellen, dass sie nicht mit dem Gerät spielen.`}</li>
      <li parentName="ul">{`Wenn das Netzkabel dieses Geräts beschädigt wird, darf es nur durch den Hersteller oder den Kundendienst oder eine ähnlich qualifizierte Person ersetzt werden, um Schäden an Ihnen und dem Gerät zu vermeiden.`}</li>
      <li parentName="ul">{`Führen Sie niemals selbst eine Reparatur durch. Wenn Sie das Gerät öffnen, erlischt automatisch die Garantie. Im Falle einer Reparatur wenden Sie sich bitte an Ihr INSTAR-Servicezentrum.`}</li>
      <li parentName="ul">{`Legen Sie das Gerät beim Reinigen niemals in Wasser.`}</li>
      <li parentName="ul">{`Stellen Sie sicher, dass Sie das Gerät nur an eine 100V - 240V Steckdose anschließen.`}</li>
      <li parentName="ul">{`Dieses Gerät ist nur für den Gebrauch in Innenräumen geeignet.`}</li>
      <li parentName="ul">{`Verwenden Sie dieses Gerät nur zur Sicherung Ihres Hauses, Büros und ähnlicher Orte. Wenn Sie das Gerät in einem öffentlichen Bereich installieren möchten, vergewissern Sie sich bitte, dass Sie über alle erforderlichen Zertifikate verfügen, um dies zu tun.`}</li>
      <li parentName="ul">{`Installieren Sie das Gerät niemals in der Nähe von explosiven oder entflammbaren Stoffen.`}</li>
      <li parentName="ul">{`Verwenden Sie die Kamera nicht für einen anderen Zweck, für den sie nicht vorgesehen ist.`}</li>
      <li parentName="ul">{`INSTAR übernimmt keine Garantie, wenn Sie Firmware oder WebUI von Drittanbietern verwenden.`}</li>
    </ul>
    <h3 {...{
      "id": "konformitätserklärung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#konformit%C3%A4tserkl%C3%A4rung",
        "aria-label": "konformitätserklärung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Konformitätserklärung`}</h3>
    <EuiSpacer mdxType="EuiSpacer" />
    <ConformityCards mdxType="ConformityCards" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      